import { useCurrencyStore } from '@/store/currencyStore';
import { Currency } from '@/types/product';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';

const CURRENCIES: { value: Currency; label: string }[] = [
  { value: 'CAD', label: 'CAD $' },
  { value: 'USD', label: 'USD $' },
  { value: 'AUD', label: 'AUD $' },
  { value: 'EUR', label: 'EUR €' },
  { value: 'GBP', label: 'GBP £' },
  { value: 'AED', label: 'AED د.إ' },
];

export const CurrencySelector = () => {
  const currency = useCurrencyStore((state) => state.currency);
  const setCurrency = useCurrencyStore((state) => state.setCurrency);

  return (
    <Select value={currency} onValueChange={(value) => setCurrency(value as Currency)}>
      <SelectTrigger className="w-[110px] bg-white border-gray-200 text-gray-900">
        <SelectValue placeholder="Currency" />
      </SelectTrigger>
      <SelectContent className="bg-white border-gray-200">
        {CURRENCIES.map((curr) => (
          <SelectItem
            key={curr.value}
            value={curr.value}
            className="text-gray-900 hover:bg-gray-100 focus:bg-gray-100"
          >
            {curr.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};
